import $store from 'STORE'

export const checkRouteAvailability = routeName => {
  return $store.getters.isRouteAvailable(routeName)
}

export const checkModuleAvailability = moduleName => {
  return $store.getters.getModuleAvailability(moduleName)
}
